import { useIntl } from 'react-intl';
import { toast } from 'react-toastify';
import { uploadHolidaySheet } from '../services/uploadHolidaySheet';
import { useState } from 'react';

export default function HolidaySheetUploadForm() {
  const intl = useIntl();
  const [file, setFile] = useState<File | null>(null);
  const [loading, setLoading] = useState(false);

  async function onFilesSelected(event: any) {
    const files = Array.from(event.target.files);
    if (files.length > 0) {
      setFile(files[0] as File);
    }
  }

  async function uploadFile() {
    try {
      setLoading(true);
      if (file) {
        await uploadHolidaySheet(file);
        toast.success(intl.formatMessage({ id: 'holidaySheet.uploadSuccess' }));
      }
    } catch (error) {
      console.error('Error uploading file:', error);
      toast.error(intl.formatMessage({ id: 'holidaySheet.uploadError' }));
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="card p-10">
      <h1 className="mb-5">
        {intl.formatMessage({ id: 'holidaySheet.title' })}
      </h1>
      <p className="mb-5">
        {intl.formatMessage({ id: 'holidaySheet.description' })}
      </p>
      <input
        type="file"
        accept=".csv"
        className="form-control mb-5"
        onChange={onFilesSelected}
        placeholder={intl.formatMessage({ id: 'holidaySheet.upload' })}
      />
      <button
        className="btn btn-primary ms-auto"
        onClick={uploadFile}
        disabled={!file || loading}
      >
        {loading ? (
          <span
            className="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
        ) : (
          intl.formatMessage({ id: 'holidaySheet.uploadButton' })
        )}
      </button>
    </div>
  );
}
